import { ROUTES } from '../lib/routes'

export type ToolLink = {
  href: (typeof ROUTES)[keyof typeof ROUTES]
  label: string
  shortLabel: string
  description: string
  popular?: boolean
}

export const TOOL_LINKS: ToolLink[] = [
  // Row 1: Primary tools (highest demand)
  {
    href: ROUTES.mergePdf,
    label: 'Merge PDF',
    shortLabel: 'Merge',
    description: 'Combine multiple PDFs into one.',
    popular: true,
  },
  {
    href: ROUTES.compressPdf,
    label: 'Compress PDF',
    shortLabel: 'Compress',
    description: 'Reduce file size while keeping quality.',
    popular: true,
  },
  {
    href: ROUTES.signPdf,
    label: 'Sign PDF',
    shortLabel: 'Sign',
    description: 'Add your signature to any PDF document.',
    popular: true,
  },
  // Row 2: Conversions & Split
  {
    href: ROUTES.pdfToJpg,
    label: 'PDF to JPG/PNG',
    shortLabel: 'PDF → Image',
    description: 'Export pages as JPG or PNG (ZIP for many).',
    popular: true,
  },
  {
    href: ROUTES.jpgToPdf,
    label: 'JPG/PNG to PDF',
    shortLabel: 'Image → PDF',
    description: 'Convert images to one PDF; reorder easily.',
  },
  {
    href: ROUTES.splitPdf,
    label: 'Split PDF',
    shortLabel: 'Split',
    description: 'Split by page range or every page.',
  },
  // Row 3: Utility tools
  {
    href: ROUTES.rotatePdf,
    label: 'Rotate PDF',
    shortLabel: 'Rotate',
    description: 'Rotate selected pages or the whole file.',
  },
  {
    href: ROUTES.deletePdfPages,
    label: 'Delete PDF Pages',
    shortLabel: 'Delete pages',
    description: 'Delete specific pages from a PDF.',
  },
]
